module.exports = __webpack_public_path__ + "img/YTSr8WDtaM1629106376130.9c6936b9.jpg";